import { Mail, MapPin, Phone } from 'lucide-react';

const ContactSection = () => (
  <section id="contacto" className="bg-slate-50 py-32">
    <div className="container mx-auto px-6">
      <div className="grid items-center gap-16 lg:grid-cols-2">
        <div className="space-y-12">
          <div>
            <h3 className="mb-6 text-5xl font-black tracking-tighter text-slate-900">Contacto</h3>
            <p className="text-lg text-slate-600">
              Ven a conocernos a nuestro centro en Las Palmas de Gran Canaria.
            </p>
          </div>

          <div className="space-y-8">
            <div className="group flex items-center gap-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white text-slate-900 shadow-md transition-colors group-hover:bg-emerald-600 group-hover:text-white">
                <MapPin size={20} />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Ubicación</p>
                <p className="text-sm font-bold">C/ Aguadulce, 22, 35004, Las Palmas</p>
              </div>
            </div>
            <div className="group flex items-center gap-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white text-slate-900 shadow-md transition-colors group-hover:bg-emerald-600 group-hover:text-white">
                <Phone size={20} />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">
                  Teléfono &amp; WhatsApp
                </p>
                <p className="text-sm font-bold">+34 670 78 48 60</p>
              </div>
            </div>
            <div className="group flex items-center gap-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white text-slate-900 shadow-md transition-colors group-hover:bg-emerald-600 group-hover:text-white">
                <Mail size={20} />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Email</p>
                <p className="text-sm font-bold">info@richardatik.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="relative h-[500px]">
          <div className="h-full overflow-hidden rounded-[3rem] border border-slate-100 bg-white p-4 shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3519.2483563914445!2d-15.429188023773172!3d28.108422607185062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc4095094276722d%3A0xe2f4477839352e0!2sCalle%20Aguadulce%2C%2022%2C%2035004%20Las%20Palmas%20de%20Gran%20Canaria%2C%20Las%20Palmas!5e0!3m2!1ses!2ses!4v1714476600000!5m2!1ses!2ses"
              className="h-full w-full rounded-[2.5rem] border-0 grayscale opacity-80"
              allowFullScreen
              loading="lazy"
              title="Google Maps Las Palmas"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection;
